export class ProductMain extends HTMLElement {
    constructor() {
        super();

        this._selectors = {
            addToCart: "[js-add-to-cart]",
            productLink: "[js-product-link]",
            sellingPlan: "[js-selling-plan]",
            sellingPlanInput: "[js-selling-plan-input]",
            subscribe: "[js-subscribe]",
            frequenciesTrigger: "[js-frequencies-trigger]",
            frequenciesContainer: "[js-frequencies-container]",
            frequecy: "[js-frequency]",
            error: "[js-error-message]",
            form: "[js-product-form]",
            loader: "loading-spinner",
        };
    }

    connectedCallback() {
        this.buttons = this.querySelectorAll(this._selectors.addToCart);
        this.productLinks = this.querySelectorAll(this._selectors.productLink);
        this.sellingPlans = this.querySelectorAll(this._selectors.sellingPlan);
        this.sellingPlanInputs = this.querySelectorAll(
            this._selectors.sellingPlanInput,
        );
        this.subscribe = this.querySelector(this._selectors.subscribe);
        this.frequenciesTrigger = this.querySelector(
            this._selectors.frequenciesTrigger,
        );
        this.frequenciesContainer = this.querySelector(
            this._selectors.frequenciesContainer,
        );
        this.frequecies = this.querySelectorAll(this._selectors.frequecy);
        this.isBundle = this.dataset.isBundle === "true";
        this.isSubscription = false;

        // document.addEventListener('rebuy:smartcart.ready', (event) => {
        //   const smartCart = event.detail.smartcart;
        //   smartCart.destroy();
        // });

        this._setListeners();
        this._initProductForm();
        this._setRecentlyViewedPdp();

        const _localViewed = localStorage.recently_viewed;
        window.onpopstate = (_event) => {
            location.reload();
        };
    }

    _setListeners() {
        if (this.productLinks) {
            this.productLinks.forEach((button) => {
                button.addEventListener("click", this._renderProductLink);
            });
        }

        if (this.sellingPlanInputs) {
            this.sellingPlanInputs.forEach((input) => {
                input.addEventListener("click", this._handleSellingPlanSelect);
            });
        }

        if (this.frequenciesTrigger) {
            this.frequenciesTrigger.addEventListener(
                "click",
                this._openFrequencies,
            );
        }

        if (this.frequenciesTrigger) {
            document.addEventListener("click", (event) => {
                if (!this.frequenciesTrigger.contains(event.target)) {
                    this.frequenciesContainer.classList.remove("active");
                }
            });
        }

        if (this.frequecies) {
            this.frequecies.forEach((label) => {
                label.addEventListener("click", this._closeFrequencies);
            });
        }
    }

    _initProductForm() {
        this.form = this.querySelector(this._selectors.form);

        // Check if the new portable snippet system is handling this form
        // If so, skip legacy handler to prevent double submission
        const hasPortableSnippet = this.querySelector(
            '.portable-snippet[data-snippet-name="product-details"]',
        );
        if (hasPortableSnippet) {
            // console.log('Portable snippet detected, skipping legacy form handler');
            return;
        }

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartDrawer = document.querySelector("#CartDrawer");
    }

    onSubmitHandler(evt) {
        evt.preventDefault();

        this.handleErrorMessage();
        this._disableButtons();

        if (this.isBundle) {
            this._handleBundleAdd();
            return;
        }

        const config = {
            method: "POST",
            headers: {
                Accept: `application/javascript`,
                "X-Requested-With": "XMLHttpRequest",
            },
        };

        const formData = new FormData(this.form);
        if (this.cart) {
            formData.append(
                "sections",
                this.cart.getSectionsToRender().map((section) => section.id),
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    theme.utils.subscriptions.publish(
                        window.PUB_SUB_EVENTS.cartError,
                        {
                            source: "product-form",
                            productVariantId: formData.get("id"),
                            errors: response.errors || response.description,
                            message: response.message,
                        },
                    );
                    this.handleErrorMessage(response.description);
                    this.error = true;
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                if (!this.error)
                    theme.utils.subscriptions.publish(
                        window.PUB_SUB_EVENTS.cartUpdate,
                        {
                            source: "product-form",
                            productVariantId: formData.get("id"),
                        },
                    );
                this.error = false;
                this.cart.renderContents(response);
                this.cartDrawer.open();
            })
            .catch((e) => {
                this.handleErrorMessage(e.description);
                console.error(e);
            })
            .finally(() => {
                this._enableButtons();
            });
    }

    handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.querySelector(this._selectors.error);

        if (errorMessage) {
            this.errorMessageWrapper.innerHTML = errorMessage;
            this.errorMessageWrapper.classList.remove("hidden");
        } else {
            this.errorMessageWrapper.classList.add("hidden");
        }
    }

    _disableButtons() {
        this.buttons.forEach((button) => {
            button.setAttribute("disabled", "");
            const loader = button.querySelector(this._selectors.loader);
            if (loader) {
                loader.setAttribute("loading", "");
            }
        });
    }

    _enableButtons() {
        this.buttons.forEach((button) => {
            button.removeAttribute("disabled");
            const loader = button.querySelector(this._selectors.loader);
            if (loader) {
                loader.removeAttribute("loading");
            }
        });
    }

    _setRecentlyViewedPdp() {
        const json = document.getElementById("ProductJSON");
        if (!json) return;

        // Get product handle
        const product = JSON.parse(json.innerHTML);
        const productData = {
            handle: product.handle,
        };
        const productArr = [];
        productArr.push(productData);

        // Init JSON response variables
        let jsonResp, jsonRespArr, jsonRespArrStr;

        // Set the variable for localStorage
        const numberOfProducts = 4;
        const currentHandle = productData.handle;
        const productDataString = JSON.stringify(productArr);
        const localData = localStorage.getItem("recently_viewed");

        // If storage is empty, store data
        if (localData == null) {
            localStorage.setItem("recently_viewed", productDataString);
        } else if (localData != null) {
            const oldProductData = localStorage.getItem("recently_viewed");
            const countProductData = (oldProductData.match(/handle/g) || [])
                .length;
            const reVisitProduct = oldProductData.includes(currentHandle);
            // Get old data, merged it with new data and, then store merged data
            if (
                countProductData < numberOfProducts &&
                reVisitProduct === false
            ) {
                jsonResp = JSON.parse(oldProductData);
                jsonRespArr = jsonResp.concat(productArr);
                jsonRespArrStr = JSON.stringify(jsonRespArr);
                localStorage.setItem("recently_viewed", jsonRespArrStr);
                // If user visited more than 4 pages delete first data
            } else if (
                countProductData >= numberOfProducts &&
                reVisitProduct === false
            ) {
                jsonResp = JSON.parse(oldProductData);
                jsonResp.shift();
                jsonRespArr = jsonResp.concat(productArr);
                jsonRespArr = JSON.stringify(jsonRespArr);
                localStorage.setItem("recently_viewed", jsonRespArr);
            }
        }
    }

    _renderProductLink = (evt) => {
        evt.preventDefault();
        const url = evt.currentTarget.dataset.url;

        fetch(`${url}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(
                    responseText,
                    "text/html",
                );
                const oldMain = document.querySelector("s-product");
                const newMain = html.querySelector("s-product");
                oldMain.innerHTML = newMain.innerHTML;
                this.connectedCallback();
                yotpoWidgetsContainer.initWidgets();
                window.history.pushState({}, "", url);
            })
            .catch((e) => {
                console.error(e);
            });
    };

    _handleSellingPlanSelect = (evt) => {
        this.sellingPlans.forEach((element) => {
            element.classList.remove("active");
        });
        evt.currentTarget.parentNode.parentNode.classList.add("active");

        const optionValue = evt.currentTarget.value
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/-$/, "")
            .replace(/^-/, "");
        if (optionValue === "subscription") {
            this.isSubscription = true;
        } else {
            this.isSubscription = false;
        }
    };

    _openFrequencies = (_evt) => {
        this.frequenciesContainer.classList.add("active");
    };

    _closeFrequencies = (_evt) => {
        this.subscribe.click();
        this.frequenciesContainer.classList.remove("active");
    };

    _handleBundleAdd = () => {
        // Init variables
        const data = {
            items: [],
            sections: this.cart
                .getSectionsToRender()
                .map((section) => section.id),
        };
        const date = new Date();

        // Get data
        const bundleElement = this.querySelector("[data-bundle-products]");
        const bundleProducts = JSON.parse(bundleElement.dataset.bundleProducts);
        const productForm = this.form;
        const mainProductId = productForm.querySelector(
            `#${productForm.dataset.masterSelect}`,
        ).value;
        const mainProductObject = {
            id: parseInt(mainProductId, 10),
            quantity: 1,
        };

        // If subscription is selected, apply main product's currently selected selling plan to all products
        if (this.isSubscription) {
            const sellingPlan =
                this.frequenciesContainer.querySelector("input:checked");
            bundleProducts.forEach((product) => {
                product.selling_plan = product[`plan_${sellingPlan.value}`];
                delete product.plan_1;
                delete product.plan_2;
                delete product.plan_3;
                delete product.plan_4;
            });
            mainProductObject.selling_plan = parseInt(
                sellingPlan.dataset.planId,
                10,
            );
        } else {
            bundleProducts.forEach((product) => {
                delete product.plan_1;
                delete product.plan_2;
                delete product.plan_3;
                delete product.plan_4;
            });
        }

        data.items = bundleProducts;
        data.items.push(mainProductObject);

        // Setting properties
        data.items.forEach((item) => {
            item.properties = {};
            item.properties._bundleName = this.dataset.title;
            item.properties._bundleId = date;
        });

        mainProductObject.properties._bundleMainProduct = true;

        // Add products to cart
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                this._enableButtons();
                location.href = "/cart";
            });
    };
}
